/* --- Function Index --- */
var site = {
  // 1st function to fire
  ready: ready,
  // 2nd function to fire
  load: load,
  scroll: scroll,
  resize: resize,
  responsive: function getResponsive() {
    var windowWidth = window.innerWidth;
    var size;
    if (windowWidth > 768) {
      size = "lg";
    } else if (windowWidth <= 768 && windowWidth > 426) {
      size = "md";
    } else if (windowWidth <= 426) {
      size = "sm";
    }

    return size;
  },
};

function ready() {
  scroll();
}


$(document).ready(function () {
  site.ready();
});

function load() {
  $(".loader-component").fadeOut("slow");
  $(".loader-image").fadeOut();
  $("main").css({
    opacity: 1,
  });
}

$(window).on("load", function () {
  site.load();
});

function resize() {
  var r = site.responsive();
}

$(window).on("resize", function () {
  site.resize();
});

// VALIDATE FORMS
(function () {
  "use strict";
  window.addEventListener(
    "load",
    function () {
      // Fetch all the forms we want to apply custom Bootstrap validation styles to
      var forms = document.getElementsByClassName("needs-validation");
      // Loop over them and prevent submission
      var validation = Array.prototype.filter.call(forms, function (form) {
        form.addEventListener(
          "submit",
          function (event) {
            if (form.checkValidity() === false) {
              event.preventDefault();
              event.stopPropagation();
            }
            form.classList.add("was-validated");
          },
          false
        );
      });
    },
    false
  );
})();

const Util = {
  getSelectorFromElement(element) {
    var selector = element.getAttribute("data-target");
    if (!selector || selector === "#") {
      selector = element.getAttribute("href") || "";
    }

    try {
      return document.querySelector(selector) ? selector : null;
    } catch (err) {
      return null;
    }
  },
  getIdFromDropdown(element) {
    var selector = element.parentElement.getAttribute("data-id");

    try {
      return document.getElementById(selector)
        ? document.getElementById(selector)
        : null;
    } catch (err) {
      return null;
    }
  },
};

// Toggle Classes for [data-toggle=] HTML tags.
/* PARAMS:
  class to toggle: data-toggle="class"
  Target to toggle above class: data-target="header, main"
*/
$(function () {
  $(document).on("click", '[data-toggle="show"]', function (event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (
      event.currentTarget.tagName === "A" &&
      $(this).data("prevent") != false
    ) {
      event.preventDefault();
    }

    const $trigger = $(this);
    const selector = Util.getSelectorFromElement(this);
    const selectors = [].slice.call(document.querySelectorAll(selector));
    $(selectors).each(function () {
      const $target = $(this);
      const $data = $trigger.data("toggle");
      $target.toggleClass($data);
      const $focus = $trigger.data("focus");
      if ($focus != "") {

        $($focus).focus();
      }

      // Cambiar el atributo tabindex a 0 para los hijos con las clases .close-search y .search-input
      if ($target.hasClass('show')) {
        $target.find('.close-search, .search-input').attr('tabindex', '0');
      } else {
        $target.find('.close-search, .search-input').attr('tabindex', '-1');
      }
    });
  });

  $(document).on("click", '[data-link="offset"]', function (event) {
    const $offset = $(this).data("link-offset");
    const $trigger = $(this).attr("href");
    $("html, body")
      .stop()
      .animate({ scrollTop: $($trigger).offset().top - $offset });
  });
});

$(function () {
  $(document).on("click keypress", '[data-toggle="active"]', function (event) {
    if (event.type === "keypress" && event.which !== 13) {
      return;
    }

    if (event.currentTarget.tagName === "A" && $(this).data("prevent") !== false) {
      event.preventDefault();
    }

    const $trigger = $(this);
    const selector = Util.getSelectorFromElement(this);
    const $siblings = $trigger.siblings();

    $siblings.removeClass('active');

    const selectors = document.querySelectorAll(selector);
    selectors.forEach((element) => {
      const $target = $(element);
      const $data = $trigger.data("toggle");
      $target.toggleClass($data);

      const $focus = $trigger.data("focus");
      if ($focus) {
        $($focus).focus();
      }

       if ($target.hasClass('active')) {
        $target.find('.submenu .nav-link').attr('tabindex', '0');
      } else {
        $target.find('.submenu .nav-link').attr('tabindex', '-1');
      }

    });
  });


  $(document).on("click", '[data-link="offset"]', function (event) {
    const $offset = $(this).data("link-offset");
    const $trigger = $(this).attr("href");
    $("html, body").stop().animate({ scrollTop: $($trigger).offset().top - $offset });
  });
});

$(document).on('focusout', function(event) {
  const submenu = $('.submenu');
  const focusedElement = event.relatedTarget;
  if (!submenu.is(focusedElement) && !submenu.has(focusedElement).length) {
    $('header').removeClass('active');
    $('.nav-item').removeClass('active');
    $('.submenu .nav-link').attr('tabindex', '-1');
  }
});

$(function() {
  function adjustHeaderTop() {
    let alturaHeader = $('header').outerHeight(true);
    let alturaAnnouncement = $('.announcement-bar').outerHeight(true);
    let altura = alturaHeader;
    $('.header-menu-wrapper').css('padding-top', altura + 'px');
    $('.header-submenu').css('top', altura + 'px');
    $('html').css('--altura-header', alturaHeader + 'px');
    if ((altura / 2.6) > 60)
      $('.section-hero-short').css('padding-top', (altura / 2.6) + 'px');
  }
  adjustHeaderTop();
  $(window).on('resize', function() {
    adjustHeaderTop();
  });
});




$(function () {
  var header = document.querySelector("header.overlap");

  if (header){
    // construct an instance of Headroom, passing the element
    var headroom = new Headroom(header, {
      offset: 100
    });
    // initialise
    headroom.init();
  }
});

$(function() {
  $('.close-search').click(function(){
    $('.search-input').val('');
  })
})

function resetInputs() {
  $('.input-price').val('')
}

$(document).ready(function() {
  const modal = $('.header-search');
  const closeButton = $('#close-search-btn');
  const searchButton = $('.search-btn');
  const overlay = $('.search-overlay');

  const cartModal = $('.modal-cart-container');
  const cartCloseBtn = $('#cart-close-btn');

  function updateModalVisibility(isVisible) {
    modal.attr('data-visible', isVisible);
    overlay.attr('data-visible', isVisible); 
  }

  searchButton.on('click', function() {
    updateModalVisibility(true);
  });

  closeButton.on('click', function() {
    updateModalVisibility(false);
  });

  overlay.on('click', function() {
    updateModalVisibility(false);
  });

  $(document).on('keydown', function(event) {
    if (event.key === 'Escape' && modal.attr('data-visible') === 'true') {
      closeButton.click();
    }
  });
  
});

function closeSearchModal() {
  const searchOverlay = document.querySelector('.search-overlay');
  const headerSearch = document.querySelector('.header-search');
  const headerRoom = document. querySelector('.headroom--top')

  if (searchOverlay && headerSearch) {
    searchOverlay.classList.remove('show');
    headerSearch.classList.remove('show');
    headerRoom.classList.remove('show');
    document.body.classList.remove('search-active');
  }
}

document.querySelectorAll('[data-close-search]').forEach(function(element) {
  element.addEventListener('click', function(event) {
    closeSearchModal();
  });
});

var checkboxes = document.getElementsByClassName('filters-check');

for (var i = 0; i < checkboxes.length; i++) {
  checkboxes[i].addEventListener('keydown', function(event) {
    if (event.keyCode === 13) { 
      this.checked = !this.checked;
    }
  });
}


$(document).ready(function() {
  $(document).on('keydown', function(event) {
      // Check if the key pressed is the ESC key
      if (event.key === 'Escape' || event.key === 'Esc') {
          // Get the cart modal element
          var $cartModal = $('#modal-cart');
          
          // Check if the cart modal is open (assuming it has a class 'open' when visible)
          if ($cartModal.hasClass('show')) {
              // Close the cart modal by removing the 'open' class
              $cartModal.removeClass('show');
          }
      }
  });
});

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


//VARIANTS




// Cursor
var cursor = $(".cursor");

function cursorInit() {
  $(window).mousemove(function (e) {
    if (cursor.hasClass("active")) {
      var offsetX = -10;
      var offsetY = -15;
      cursor.css({
        top: e.clientY + offsetY,
        left: e.clientX + offsetX
      });
    }
  });

  $(document).on("mouseenter", "a, button, .swiper-button-next, .addresses input[type=checkbox], facet-filters-form input[type=checkbox], .selectize-control .selectize-input>.item, select, .selectize-control .selectize-dropdown .option, .jdgm-btn, input[type=submit].jdgm-btn", function () {
    cursor.addClass("active").css({ opacity: "1" });
  });
  
  $(document).on("mouseleave", "a, button, .swiper-button-next, .addresses input[type=checkbox], facet-filters-form input[type=checkbox], .selectize-control .selectize-input>.item, select, .selectize-control .selectize-dropdown .option, .jdgm-btn, input[type=submit].jdgm-btn", function () {
    cursor.removeClass("active").css({ opacity: "0" });
  });
  
}

$(document).ready(function () {
  cursorInit();
});
